import { useState } from 'react';

type Option = {
  label: string;
  value: string;
};

type Props = {
  options: Record<string, string>[];
  disabled?: boolean;
  className: string;
  getLabel: any;
};

export default function SelectHorizontalColumns({ options, disabled, className, getLabel }: Props) {
  const [selected, setSelected] = useState<string[]>([]);

  const toggle = (value: string) => {
    if (selected.includes(value)) {
      setSelected(selected.filter((v) => v !== value));
    } else {
      setSelected([...selected, value]);
    }
  };

  return (
    <div className="grid grid-cols-2 gap-x-10 gap-y-2">
      {options.map((opt) => (
        <label key={opt.value} className="flex items-center gap-2 text-[#621C43]">
          <input
            type="checkbox"
            checked={selected.includes(opt.value)}
            onChange={() => toggle(opt.value)}
            disabled={disabled}
            className="accent-[#C0275E] w-4 h-4"
          />
          {getLabel(opt)}
        </label>
      ))}
    </div>
  );
}
